import { ContractStatusData } from './contract-status-data';
import { CustomerStatusData } from './customer-status-data';
import { DefectTypeData } from './defect-type-data';
import { DesignTypeData } from './design-type-data';
import { InspectionDefectStatusTypeData } from './inspection-defect-status-type-data';
import { InspectionOutcomeData } from './inspection-outcome-data';
import { InspectionTypeData } from './inspection-type-data';
import { InspectionTypeGroupData } from './inspection-type-group-data';
import { LoadingLimitData } from './loading-limit-data';
import { MethodsOfCladdingData } from './methods-of-cladding-data';
import { MethodOfTyingData } from './method-of-tying-data';
import { ScaffoldStatusData } from './scaffold-status-data';
import { ScaffoldTypeData } from './scaffold-type-data';
import { SiteStatusData } from './site-status-data';
import { HandoverRiskReasonData } from './handover-risk-reason-data';
import { HandoverRiskTypeData } from './handover-risk-type-data';
import { RolesData } from './roles-data';
import { ContactTypeData } from './contact-type-data';
import { DepotData } from './depot-data';
import { DiaryCategoryData } from './diary-category-data';
import { TaskTypeData } from './task-type-data';
import { RateTypeData } from './rate-type-data';
import { ExpenseTypeData } from './expense-type-data';
import { ContractTypeData } from './contract-type-data';
import { ScaffoldingSystemTypeData } from './scaffolding-system-type-data';
import { HandoverSettingsData } from './handover-settings-data';
import { ReportSectionData } from './report-section-data';
import { CompanyDetails } from './company-details';
import { CompanyStatisticData } from './company-statistic-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ConfigurationData {
  ConfigurationId: boolean;
  SchemaVersion: string;
  ContractStatuses: { [key: string]: ContractStatusData };
  CustomerStatuses: { [key: string]: CustomerStatusData };
  DefectTypes: { [key: string]: DefectTypeData };
  DesignTypes: { [key: string]: DesignTypeData };
  InspectionDefectStatuses: { [key: string]: InspectionDefectStatusTypeData };
  InspectionOutcomes: { [key: string]: InspectionOutcomeData };
  InspectionTypes: { [key: string]: InspectionTypeData };
  InspectionTypeGroup: { [key: string]: InspectionTypeGroupData };
  LoadingLimits: { [key: string]: LoadingLimitData };
  MethodOfCladdings: { [key: string]: MethodsOfCladdingData };
  MethodOfTyings: { [key: string]: MethodOfTyingData };
  ScaffoldStatuses: { [key: string]: ScaffoldStatusData };
  ScaffoldTypes: { [key: string]: ScaffoldTypeData };
  SiteStatuses: { [key: string]: SiteStatusData };
  HandoverRiskReasons: { [key: string]: HandoverRiskReasonData };
  HandoverRiskTypes: { [key: string]: HandoverRiskTypeData };
  Roles: { [key: string]: RolesData };
  ContactTypes: { [key: string]: ContactTypeData };
  SiteDepots: { [key: string]: DepotData };
  DiaryCategories: { [key: string]: DiaryCategoryData };
  TaskTypes: { [key: string]: TaskTypeData };
  RateTypes: { [key: string]: RateTypeData };
  ExpenseTypes: { [key: string]: ExpenseTypeData };
  ContractTypes: { [key: string]: ContractTypeData };
  ScaffoldingSystems: { [key: string]: ScaffoldingSystemTypeData };
  HandoverSettings: { [key: string]: HandoverSettingsData };
  ReportSections: { [key: string]: ReportSectionData };
  CompanyDetails: CompanyDetails;
  CurrencySymbol: string;
  CustomerReferencePrefix: string;
  CustomerReferenceSuffix: string;
  CustomerReferenceLength: number;
  SiteReferencePrefix: string;
  SiteReferenceSuffix: string;
  SiteReferenceLength: number;
  ScaffoldReferencePrefix: string;
  ScaffoldReferenceSuffix: string;
  ScaffoldReferenceLength: number;
  ContractReferencePrefix: string;
  ContractReferenceSuffix: string;
  ContractReferenceLength: number;
  NewSiteStatusId: string;
  NewContractStatusId: string;
  NewContractContactStatusId: string;
  NewCustomerStatusId: string;
  CompanyStatisticData: CompanyStatisticData;
  Deleted: boolean;
  LastModified: string;
  InspectionReportPrefix: string;
}


